export class UsersFilter {
  pin: string | null;
  fullName: string | null;
  phoneNumber: string | null;
  rolesIds: number[] | null;
  positionIds: number[] | null;
  departmentIds: number[] | null;
  governmentIds: number[] | null;
  isBanned: boolean = false;
  page: number = 1;
  size: number = 30;
  constructor(){
  
    this.pin = null;
    this.fullName = null;
    this.phoneNumber = null;
    this.rolesIds = null;
    this.positionIds = null;
    this.departmentIds = null;
    this.governmentIds = null;
  }
}
